module.exports = __webpack_public_path__ + "img/Kerala-Sec.aebb8037.jpg";